export const LOGIN_REQUESTED = "AUTH_REQUESTED";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";

// ----------------------signup-------------------------
export const SIGNUP_REQUESTED="SIGNUP_REQUESTED"
export const SIGNUP_SUCCESS="SIGNUP_SUCCESS";
export const SIGNUP_FAIL="SIGNUP_FAIL";


export const SIGNUP = "SIGNUP";
export const AUTH_LOGOUT = "auth/logout";
